import $ from 'jquery';
function publishNewsletterSignup() {
    Shopify.analytics.publish('newsletter_signup', {
        event: 'Newsletter Subscription'
    });
}
const bind = (element)=>{
    const form = $(element);
    const id = form.attr('id');
    const sourceTag = form.attr('data-source') || '$embed';
    if (!window.KlaviyoSubscribe || !window.KlaviyoSubscribe.attachToForms) {
        return;
    }
    window.KlaviyoSubscribe.attachToForms('#' + id, {
        success () {
            form.addClass('success');
            publishNewsletterSignup();
        },
        extra_properties: {
            $method_type: 'Klaviyo Form',
            $method_id: 'embed',
            $source: sourceTag
        },
        success_message: 'Thank you for subscribing!'
    });
};
export const init = async function() {
    const containers = $('[data-js-newsletter]');
    $(()=>containers.each((_, e)=>bind(e)));
};
